import {User} from '@/api'

const mixin = {
  data() {
    return{
      login:{},
    }
  },
  created() {
    // this.login = JSON.parse(sessionStorage.getItem('loginUser'))
    this.login = this.$cookies.get('loginUser');
  },
  computed:{
    // 计算监听数据
    language(){
      return  this.$store.state.languageType
    }
  },
  methods:{
    // 获取当前语言版本的文字
    backLanguageText(component){
      this.languageDataObj = this.$language.changeLanguageType(this.language,component);
    },
    // 根剧获取的窗口监听到的大小切换 手机端 / Pc端
    getToolWindow(){
      window.addEventListener('resize',this.boxChange,false)
    },
    boxChange(){
      let windowBoxWidth = window.screen.width
      let urls = this.$route.fullPath
      // console.log('打印窗口宽高',windowBoxWidth,urls)

      if( windowBoxWidth > 768){
        // PCduan
        switch(urls){
          case '/phoneindex':
            this.$router.replace('/')
            break;
          case '/phoneaboutyedeer':
            this.$router.replace('/aboutyedeer')
            break;
        }
      }else{ //手机端
        switch(urls){
          case '/':
            this.$router.replace('/phoneindex')
            break;
          case '/yedeersindex':
            this.$router.replace('/phoneindex')
            break;
          case '/aboutyedeer':
            this.$router.replace('/phoneaboutyedeer')
            break;
        }
      }

    },
    checkIt(what){
        //  判断是否填写基础信息---true--跳转到基础信息页面
        User.getWsgrxxtx({
          supUserId:this.login.supUserId,
          yuyan:this.language
        }).then((res)=>{
          // // console.log('xsbxusxbsu',res)
          // res.result = true
          // res.type = 0
          if(res.type == 0 && what == 'basic') {return;}
          // if(res.type == 1 && what == 'myresume') {return;}
          if(res.result){
            this.$confirm(res.msg,{
              confirmButtonText:'Yes',
              cancelButtonText:'No',
              type:'warning',
              showCancelButton: false, //不显示取消按钮
              showClose: false, //是否显示右上角的x
              closeOnClickModal: false, //是否可以点击空白处关闭弹窗
            }).then(()=>{
              if(res.type == 0){
                this.$router.push({path:'/personalcenter/basicinformation'})
              }
              // else
              // if(res.type == 1){
              //   this.$router.push({path:'/personalcenter/myresume'})
              // }
            }).catch(()=>{
        
            })
          }
        })
    },
    checkItJS(what){
      //  判断是否填写基础信息---true--跳转到基础信息页面
      User.getWsgrxxtxJS({
        supUserId:this.login.supUserId,
        yuyan:this.language
      }).then((res)=>{
        // // console.log('xsbxusxbsu',res)
        // res.result = true
        // res.type = 0
        if(res.type == 0 && what == 'basic') {return;}
        // if(res.type == 1 && what == 'myresume') {return;}
        if(res.result){
          this.$confirm(res.msg,{
            confirmButtonText:'Yes',
            cancelButtonText:'No',
            type:'warning',
            showCancelButton: false, //不显示取消按钮
            showClose: false, //是否显示右上角的x
            closeOnClickModal: false, //是否可以点击空白处关闭弹窗
          }).then(()=>{
            if(res.type == 0){
              this.$router.push({path:'/personalcenter/basicinformation', query: {jsBoolean: true}})
            } else if(res.type == 1){
              this.$router.push({path:'/personalcenter/myresume', query: {jsBoolean: true}})
            }
          }).catch(()=>{
      
          })
        }
      })
    },
    getUnreadMsg(){
      User.getUnreadMsg({
        supUserId:this.login.supUserId,
        yuyan:this.language
      }).then((res)=>{
        // // console.log(res)
        // this.msgData = res
        this.$store.commit('overviewData',res)
        // this.$forceUpdate()
      }).catch((error)=>{
        // console.log(error)
      })
    },
    validateFieldList(formName,validateList) {
      // 需要校验的字段
      // let fieldsToValidate = ['name', 'age'];
      let result;
      // 将回调转换为Promise
      Promise.all(
        validateList.map((field) => {
          return new Promise((resolve, reject) => {
            this.$refs[formName].validateField(field, (errorMessage) => {
              resolve(errorMessage);
            });
          });
        })
      ).then((errorMessages) => { 
        // // console.info(errorMessages);
        //  ['请输入姓名', '请输入年龄']

        // errorMessages 里是各个字段的验证错误信息, 如果数组里全为空串则所有验证通过
        // 判断errorMessages 里是否全是空串
        let valid = errorMessages.every((errorMessage) => {
          return errorMessage == '';
        });
        result = valid 
        // console.log(valid); // true/false
      });
      return result;
    },
  }
}
export default mixin;


